import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

/**
 * Prevent "Unknown promise rejection reason" overlay when rejections lack proper Error shape.
 * Common when auth refresh fails or APIs return non-Error objects. Use capture phase to run
 * before the error overlay, and preventDefault to suppress the overlay for these cases.
 */
window.addEventListener(
  'unhandledrejection',
  (event: PromiseRejectionEvent) => {
    const reason = event.reason;
    const hasValidMessage =
      reason instanceof Error ||
      (typeof reason === 'object' &&
        reason !== null &&
        typeof (reason as { message?: unknown }).message === 'string');
    if (!hasValidMessage) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const msg =
        typeof reason === 'object' && reason !== null && 'data' in reason
          ? String((reason as { data?: { title?: string } }).data?.title ?? reason)
          : String(reason ?? 'Unknown error');
      // eslint-disable-next-line no-console -- intentional logging for unhandled rejections
      console.error('Unhandled promise rejection:', msg, reason);
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
